import { render } from "./RotatingWords.vue?vue&type=template&id=748bba50"
import script from "./RotatingWords.vue?vue&type=script&lang=js"
export * from "./RotatingWords.vue?vue&type=script&lang=js"

import "./RotatingWords.vue?vue&type=style&index=0&id=748bba50&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__